module.exports = __webpack_public_path__ + "img/verified.1867e297.svg";